import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changeWorkOrder } from "../repositories/MillSetupRepository";

interface UseChangeWorkOrderOptions {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
}

export const useChangeWorkOrder = ({
	onSuccess,
	onError,
}: UseChangeWorkOrderOptions = {}) => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: changeWorkOrder,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["millSetup"] });
			onSuccess?.();
		},
		onError: (error: Error) => {
			onError?.(error);
		},
	});

	return {
		changeWorkOrder: mutation.mutate,
		isChangingWorkOrder: mutation.isPending,
	};
};
